'use client'

import { useEffect, useRef } from 'react'
import { ScrollArea, Stepper, StepperStep } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActiveStepInfo, APP_SUBMITTED, IndividualStep } from '@phoenix-web/utils/journey'
import styles from './Timeline.module.css'

const COMPLETED_ITEM_WIDTH = 122

const Timeline = ({
  activeStepInfo,
  steps,
  inactive,
  mobileBreakpoint,
  isMortgageBrokerLoan,
}: {
  activeStepInfo: ActiveStepInfo
  steps: IndividualStep[]
  inactive?: boolean
  mobileBreakpoint?: string
  isMortgageBrokerLoan?: boolean
}) => {
  const isMobile = useMediaQuery(`(max-width: ${mobileBreakpoint})`)

  const viewport = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isMobile && viewport.current) {
      const offset = viewport.current?.offsetWidth || 0
      const scrollVal = (activeStepInfo.stepNumber - 1) * COMPLETED_ITEM_WIDTH + COMPLETED_ITEM_WIDTH / 2 - offset / 2
      viewport.current?.scrollTo({ left: scrollVal, behavior: 'smooth' })
    }
  }, [activeStepInfo, isMobile, steps.length])

  return (
    <ScrollArea scrollbarSize={10} viewportRef={viewport}>
      <Stepper
        active={activeStepInfo.stepNumber}
        classNames={{
          root: styles.stepper,
          step: styles.step,
          steps: styles.steps,
          stepBody: styles.stepBody,
          stepLabel: styles.stepLabel,
          stepIcon: styles.stepIcon,
          separator: styles.separator,
        }}
        style={inactive ? { opacity: '0.7', filter: 'saturate(25%)' } : undefined}
        iconPosition="right"
      >
        {steps.map((step, index) => (
          <StepperStep
            key={index}
            label={step.value === APP_SUBMITTED && isMortgageBrokerLoan ? 'App Received' : step.label}
            completedIcon={
              <FontAwesomeIcon
                style={{
                  marginRight: '-5px',
                  backgroundColor: 'var(--mantine-color-unique-5)',
                  borderRadius: '50px',
                  width: '12px',
                  height: '12px',
                  padding: '5px',
                }}
                icon={faCheck}
              />
            }
          />
        ))}
      </Stepper>
    </ScrollArea>
  )
}

export default Timeline
